import powerBiDarkTheme from './powerBiDarkTheme.json';
import powerBiLightTheme from './powerBiLightTheme.json';

export const getPowerBiTheme = (isDarkMode) => ({
  themeJson: isDarkMode ? powerBiDarkTheme : powerBiLightTheme,
});
